import React from 'react';
import { Radio, Select, Input, Pagination, Button } from 'antd';
import { FiRotateCw } from 'react-icons/fi';
import { BsSearch } from 'react-icons/bs';
import { DAG_LIST_LIMIT, PAUSED_FILTER_TABS } from '../constants';
import { useDagsTab } from './use-dags-tab';
import { DagTable } from './dag-table';
import { TriggerDagDialog } from './trigger-dag-dialog';
import styles from '../styles.module.scss';

const { Option } = Select;

/*
 * DAGs list tab — filters, search, sortable table, pause/trigger/delete actions, pagination
 */
export function DagsTab() {
    const {
        dags,
        totalEntries,
        isLoading,
        isRefreshing,
        searchInput,
        pausedFilter,
        filterCounts,
        tagFilter,
        availableTags,
        sorting,
        togglingDagId,
        triggerDialogDagId,
        currentPage,
        handleSearchChange,
        handleRefresh,
        handlePausedFilterChange,
        handleTagFilterChange,
        setSorting,
        handleTogglePause,
        handleTriggerRequest,
        handleTriggerDialogClose,
        handleDeleteRequest,
        handleRowClick,
        handlePageChange,
    } = useDagsTab();

    return (
        <div className={styles.card}>
            <div className={styles.filterRow}>
                <Button className="refreshButton" loading={isRefreshing} onClick={handleRefresh}>
                    {!isRefreshing && <FiRotateCw />}
                </Button>
                <Radio.Group value={pausedFilter} onChange={(e) => handlePausedFilterChange(e.target.value)} buttonStyle="solid">
                    {PAUSED_FILTER_TABS.map((option) => (
                        <Radio.Button key={option.value} value={option.value}>
                            {`${option.label} ${filterCounts[option.value]}`}
                        </Radio.Button>
                    ))}
                </Radio.Group>
            </div>
            <div className={styles.filterRow}>
                <Select value={tagFilter || undefined} placeholder="All Tags" allowClear style={{ width: 180 }} onChange={(value) => handleTagFilterChange(value ?? '')}>
                    <Option value="">All Tags</Option>
                    {availableTags.map((tag) => (
                        <Option key={tag} value={tag}>
                            {tag}
                        </Option>
                    ))}
                </Select>
                <div className={styles.filterRowEnd}>
                    <Input
                        className={styles.searchInput}
                        prefix={<BsSearch />}
                        placeholder="Search DAGs"
                        value={searchInput}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        allowClear
                    />
                </div>
            </div>
            <DagTable
                dags={dags}
                isLoading={isLoading}
                sorting={sorting}
                onSortingChange={setSorting}
                togglingDagId={togglingDagId}
                onTogglePause={handleTogglePause}
                onTriggerRequest={handleTriggerRequest}
                onDeleteRequest={handleDeleteRequest}
                onRowClick={handleRowClick}
            />
            {totalEntries > DAG_LIST_LIMIT && (
                <div className={styles.paginationRow}>
                    <Pagination current={currentPage} total={totalEntries} pageSize={DAG_LIST_LIMIT} onChange={handlePageChange} showSizeChanger={false} />
                </div>
            )}
            {triggerDialogDagId && <TriggerDagDialog dagId={triggerDialogDagId} onClose={handleTriggerDialogClose} />}
        </div>
    );
}
